enum EmailStatus {
  ERRORED = "errored",
  SENT = "sent",
  SENDING = "sending",
  SUBMITTED = "submitted",
  CANCELLED = "cancelled",
}

export default EmailStatus;
